import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to scroll to top on route change
 * Handles multiple scroll methods for cross-browser/device compatibility
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      // Try multiple methods for maximum compatibility
      
      // Method 1: Window scroll (most common)
      try {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant'
        });
      } catch (e) {
        window.scrollTo(0, 0);
      }

      // Method 2: Document element (for some mobile browsers)
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
        document.documentElement.scrollLeft = 0;
      }

      // Method 3: Body scroll (for legacy browsers)
      if (document.body) {
        document.body.scrollTop = 0;
        document.body.scrollLeft = 0;
      }

      // Method 4: Root element (#root)
      const rootElement = document.getElementById('root');
      if (rootElement) {
        rootElement.scrollTop = 0;
      }

      // Method 5: Force layout recalculation (iOS Safari)
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });
    };

    // Execute scroll immediately
    scrollToTop();

    // Also execute after a short delay to handle async rendering
    const timer = setTimeout(scrollToTop, 50);

    return () => clearTimeout(timer);
  }, [pathname]);
};

export default useScrollToTop;
